<template>
	<div id="resultCard" class="box full-height">
		<div class="columns">
			<div class="column is-8">
				<div class="mb-2">
					<a @click="Navigate" class="breathe-sm"><b> {{ result.FirstName }} {{ result.LastName }} </b></a>

					<b-tooltip position="is-bottom" :triggers="['hover']" :auto-close="['outside', 'escape']">
						<a @click="flagUser('337ab7', result.Id)"><i :class="[isFlagged ? 'fas' : 'far', 'fa-flag']" v-bind:style="(isFlagged == true) ? flagStyle : 'color: black'"></i></a>
						<template v-slot:content>
							<div class="flags">
								<i class="clickable fa fa-flag" style="color:#337ab7" @click="flagUser('337ab7')"></i>&nbsp;
								<i class="clickable fa fa-flag" style="color:#ff0000" @click="flagUser('ff0000')"></i>&nbsp;
								<i class="clickable fa fa-flag" style="color:#0aba00" @click="flagUser('0aba00')"></i>&nbsp;
								<i class="clickable fa fa-flag" style="color:#4800e4" @click="flagUser('4800e4')"></i>&nbsp;
								<i class="clickable fa fa-flag" style="color:#ff6a00" @click="flagUser('ff6a00')"></i>
								<i class="clickable fa fa-times" style="color:red" @click="flagUser('')"></i>
							</div>
						</template>
					</b-tooltip>
				</div>
				<p class="resultText">{{result.PresentJobTitles[0]}}</p>
				<p class="resultText">{{result.PresentCompanies[0]}}</p>
				<p class="resultText" v-if="result.PresentCompensation || ($store.getters.showCompensation && !$store.getters.hideCompensation)"><span v-html="$currency.range(result.PresentCompensation)"></span></p>
				<p class="resultText" v-if="result.TargetCompensation || ($store.getters.showCompensation && $store.getters.hideCompensation)"><span v-html="$currency.range(result.TargetCompensation)"></span> Expected</p>
			</div>
			<div style="position:relative;" @click="Navigate" class="column is-4">
				<span style="position:absolute; top: 0; right: 0; z-index: 1;" v-show="result.HasViewed">
					<i class="fa fa-eye"></i>
				</span>
				<div class="is-pulled-right">
					<b-image :src="$BSDB_API + result.photoSrc" src-fallback="/silhouette.png">
						<template #placeholder>
							<b-skeleton width="80px" height="80px"></b-skeleton>
						</template>
					</b-image>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			result: Object
		},
		data() {
			return {
				showFlags: false,
				isFlagged: false,
				flagColor: 'black'
			}
		},
		created() {
			this.isFlagged = this.result.IsFlagged;
		},
		computed: {
			flagStyle() {
				if (this.isFlagged == true) {
					return "color: #" + this.result.FlagColor + "!important";
				}
				else {
					return "color: black";
				}
			}
		},
		methods: {
			flagUser(color) {
				this.$http.post("api/profile/flag/" + this.result.UserId, { Color: color })
					.then(resp => {
						if (resp.data == true) {
							this.$buefy.toast.open("User flagged");
							this.isFlagged = true;
							this.$set(this.result, "FlagColor", color);
						}
						else {
							this.$buefy.toast.open("User flag removed");
							this.isFlagged = false;

						}
						this.$http.get("api/profile/flagged")
							.then(resp => {
								if (resp.data.flagged.length > 0) {
									this.$store.dispatch('setFlaggedProfiles', resp.data);
								}
							}).catch(err => {
								console.log(err);
							})

					}).catch(err => {
						console.log(err);
					})
			},
			Navigate() {
				this.$emit("click");
				this.$router.push('profile/' + this.result.UserId);
			}
		}
	}
</script>

<style>


	.resultText {
	}

	#resultCard {
		cursor: pointer;
	}

		#resultCard .tooltip-content {
			background: white;
		}
	/*flag color selector menu*/
	/*#resultCard .menu {
		position: absolute;
		width: auto;
		background: #dbdbdb;
		overflow: hidden;
		text-align: center;
		opacity: 0;
		border: solid 1px black;
		margin-left: 50px;
		visibility: hidden;
	}

	#resultCard .menu-show {
		opacity: 1;
		visibility: visible;
	}*/
</style>
